import React from "react";

export const FIcon = ({ name, className }: { name: string; className?: string }) => (
  <i className={`icn_${name}${className ? " " + className : ""}`} />
);
